import { fetchTimeOffCustomFieldsQueryConfig } from 'modals/TimeOffModal/TimeOffModal.constants';
import { fetchJaneQueryConfig } from 'modals/TimeOffModal/views/CreateTimeOffView/CreateTimeOffView.constants';
import { FEATURE_SELECTORS_MAP } from 'guards/FeatureGuard.constants';
import { useGQLQuery, useSSFBehaviors, useURLParameters } from 'hooks';
import { useEffect } from 'react';
import { FC, useContext, useMemo } from 'react';
import { TimeOffFetchJaneQuery, CustomField } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';
import { useSelector } from 'react-redux';

export const CreateTimeOffViewDataContext = createGQLDataContext({});

export const CreateTimeOffViewDataProvider: FC = ({ children }) => {
  const [{ jane_id }] =
    useURLParameters<{
      jane_id: string;
    }>();

  const selectedLocation = getCurrentlySelectedLocation();
  const selectedFacilityId: number = Number(selectedLocation.value);
  const { data: fetchTimeOffCustomFields, fetch } = useGQLQuery(
    fetchTimeOffCustomFieldsQueryConfig({ byFacilityId: selectedFacilityId }),
  );

  const isCustomFieldsEnabled = useSelector(FEATURE_SELECTORS_MAP['FEATURE_TYPE_CUSTOM_FIELDS']);

  useEffect(() => {
    if (isCustomFieldsEnabled && !!selectedFacilityId) fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFacilityId]);

  const [values, opts] = useSSFBehaviors(fetchJaneQueryConfig({ janeId: jane_id }));

  const timeOffCustomFields = Object.values(fetchTimeOffCustomFields);

  const value = useMemo(() => {
    return {
      ...values,
      timeOffCustomFields,
      ...opts,
    };
  }, [timeOffCustomFields, opts, values]);

  return (
    <CreateTimeOffViewDataContext.Provider value={value}>
      {children}
    </CreateTimeOffViewDataContext.Provider>
  );
};

export interface ICreateTimeOffViewDataContext {
  timeOffCustomFields: CustomField[];
  data: TimeOffFetchJaneQuery;
}

export const useCreateTimeOffViewDataContext = (): ICreateTimeOffViewDataContext =>
  useContext(CreateTimeOffViewDataContext);
